export default {
  GET_TRANSAKSI_PAGE: (state, data) => {
    state.transaksiPage = data;
  },
  GET_TOTAL_DATA: (state, data) => {
    state.total = data;
  },
};
